import React from "react";
import PropTypes from "prop-types";

export default function Cog(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1875 7.50002C13.1875 7.25815 13.1652 7.01627 13.1332 6.7744C13.1119 6.61035 13.1806 6.44723 13.3154 6.34497L15 5.06621L13.4151 2.41404L11.4313 3.18655C11.2725 3.24934 11.0895 3.225 10.953 3.12186C10.557 2.82374 10.1398 2.58749 9.676 2.39905C9.51815 2.33533 9.40683 2.19563 9.38359 2.0325L9.08829 0H5.85362L5.61545 2.04376C5.59222 2.20596 5.48284 2.34469 5.32695 2.40938C4.85642 2.60441 4.42556 2.84909 4.04702 3.13408C3.90951 3.23625 3.72752 3.26064 3.56873 3.19876L1.58495 2.42625L4.5358e-05 5.07843L1.68466 6.35719C1.82017 6.45936 1.88797 6.62341 1.86569 6.78842C1.83374 7.01904 1.81146 7.25903 1.81146 7.49998C1.81146 7.74185 1.83374 7.98373 1.86664 8.22468C1.88793 8.38877 1.81917 8.55189 1.68461 8.65406L0 9.93282L1.58482 12.585L3.56859 11.8125C3.72834 11.7497 3.91033 11.775 4.04588 11.8781C4.44285 12.1763 4.8611 12.4134 5.32291 12.601C5.48076 12.6647 5.59208 12.8044 5.61532 12.9675L5.91062 15H9.14529L9.38346 12.9562C9.40669 12.794 9.51607 12.6553 9.67196 12.5906C10.1425 12.3947 10.5734 12.1519 10.9519 11.8659C11.0884 11.7628 11.2704 11.7375 11.4302 11.8012L13.414 12.5737L14.9989 9.92157L13.3143 8.64281C13.1787 8.54064 13.1109 8.37659 13.1332 8.21158C13.1652 7.98096 13.1875 7.74097 13.1875 7.50002ZM7.49943 10.3125C9.10355 10.3125 10.4039 9.05332 10.4039 7.50002C10.4039 5.94673 9.10355 4.68754 7.49943 4.68754C5.89532 4.68754 4.59493 5.94673 4.59493 7.50002C4.59493 9.05332 5.89532 10.3125 7.49943 10.3125Z"
        fill={props.fill}
      />
    </svg>
  );
}
Cog.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func
};
Cog.defaultProps = {
  className: "",
  fill: "#063AC9",
  width: 15,
  height: 15,
  onClick: () => null
};
